import React from "react";
import "./Footer.css";

const Footer = () => {
    return (
        <div className="footer">
            <div>Movie App</div>
            <div>©2022, Rohitkumar Chavan</div>
        </div>
    );
};

export default Footer;